export { Cbullshitcoding, CbullshitcodingFlow, CbullshitcodingTimingEventType, colorizeMarkup } from './Cbullshitcoding';
export type { CbullshitcodingProps, CbullshitcodingTimingEvent } from './Cbullshitcoding';
